/**
 * Список видеоинструкций: ключ перевода названия и URL видео.
 * При клике открывается /instructions?key={url}.
 */
export const instructionsList = [
    {
        titleKey: 'instructions_video_invoice',
        url: 'https://s3.twcstorage.ru/8a6e091b-publick/invoice1123.mp4',
    },
    {
        titleKey: 'instructions_video_templates',
        url: 'https://s3.twcstorage.ru/8a6e091b-publick/template123.mp4',
    },
    {
        titleKey: 'instructions_video_calculation',
        url: 'https://s3.twcstorage.ru/8a6e091b-publick/calculation123.mp4',
    },
    {
        titleKey: 'instructions_video_claims',
        url: 'https://s3.twcstorage.ru/8a6e091b-publick/claims123.mp4',
    },
    {
        titleKey: 'instructions_video_tracking',
        url: 'https://s3.twcstorage.ru/8a6e091b-publick/tracking123.mp4',
    },
    {
        titleKey: 'instructions_video_contracts',
        url: 'https://s3.twcstorage.ru/8a6e091b-publick/contract123.mp4',
    },
    {
        titleKey: 'instructions_video_employees',
        url: 'https://s3.twcstorage.ru/8a6e091b-publick/employees123.mp4',
    },
    {
        titleKey: 'instructions_video_chat',
        url: 'https://s3.twcstorage.ru/8a6e091b-publick/chat123.mp4',
    },
];
